import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { playerColor } from './theme';

/** Each seat's colour (hex), provided by whoever knows the players' choices: the game screen or the lobby. */
export const SeatColors = createContext<readonly string[] | null>(null);

/** `seat → colour`, falling back to the palette in seat order. */
export function useSeatColor(): (seat: number) => string {
  const colors = useContext(SeatColors);
  return (seat) => colors?.[seat] ?? playerColor(seat);
}
